export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/identity.js
// module id = 270
// module chunks = 0